import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root'
})
export class WasteService {

  constructor(private http: HttpClient) { }
get baseUrl(): string { return Constants.CORE_API_BASE_URL; }

  getWaste(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Waste/GetWaste', data);
  }

  getProcessOrder(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Waste/GetProcessOrder', data);
  }
  
  getUnitByPlant(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CIL/GetUnitByPlantUpload', data);
  }
  
  getWasteFaultByUnit(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetWasteFaultByUnit', data);
  }

  addWasteEntery(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Waste/AddWasteEntry', data);
  }
  
  getWasteEntryHistory(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Waste/getWasteEntryHistory', data);
  }

  updateWasteEntry(data: any):  Observable<any[]>
  {
    return this.http.post<any[]>(this.baseUrl + 'Waste/updateWasteEntry', data);
  }
  
  // getWaste(data: any): Observable<any[]> {
  //   return this.http.post<any[]>(this.baseUrl + 'Common/GetGroup', data);
  // }
}
